import React, { useEffect } from 'react'
import './WhiteMenuSection.scss'
import Arrow2 from '../Images/Arrowblack.svg'
import OrangeButton2 from './OrangeButton2'
import DecoIco1 from '../Images/decoIco3.svg'
import DecoIco2 from '../Images/decoIco1.svg'
import DecoIco3 from '../Images/decoIco5.svg'




function WhiteMenuSection() {

    useEffect(() => {
        const handleClick = (event) => {
            const titleContainer = event.currentTarget;
            const arrow = titleContainer.querySelector('.arrow-right');
            const descriptionParent = titleContainer.querySelector('.description-parent');
            const descriptionChild = titleContainer.querySelector('.description-child')

            if (arrow.classList.contains('arrow-right-active')) {
                arrow.classList.remove('arrow-right-active');
            } else {
                arrow.classList.add('arrow-right-active');
            }

            if (descriptionParent.classList.contains('description-parent-active')) {
                descriptionParent.classList.remove('description-parent-active');
                descriptionParent.style.height = 0;
            } else {
                descriptionParent.classList.add('description-parent-active');
                descriptionParent.style.height = descriptionChild.offsetHeight + 50 + 'px';
            }
        };

        const titleContainers = document.querySelectorAll('.title');

        titleContainers.forEach((titleContainer) => {
            titleContainer.addEventListener('click', handleClick);
        });

        return () => {
            titleContainers.forEach((titleContainer) => {
                titleContainer.removeEventListener('click', handleClick);
            });
        };

    }, []);

    return (
        <div className='white-menu-section full-width'>
            <div className='white-menu-grid main-grid'>
                <div className='white-menu-left' id='contact-form'>

                    <h3 className='unbounded-font'>
                        Our UX/UI services include:
                    </h3>


                    <p className='description inter-font' >
                        Achieve dynamic growth with our tailored strategy. Let the results speak for themselves. Discover the power of our advanced web solutions today. We’ll help elevate your brand to new heights with our exceptional designs and innovative strategies, ensuring your travel business stands out in a competitive market.
                    </p>


                    <div className='contact-form-div' >

                        <p className='contact-description'>
                            Looking for a way to grow your business? Our web design agency provides solutions tailored to your needs that deliver exceptional results. Contact us and unlock the full potential of your brand online.
                        </p>

                        <div className='icons-and-button'>

                            <div className='deco-icons'>

                                <img src={DecoIco1} alt='decoration icon' className='deco-icon' />
                                <img src={DecoIco2} alt='decoration icon' className='deco-icon' />
                                <img src={DecoIco3} alt='decoration icon' className='deco-icon' />
                            </div>
                            <div className='button-send'>
                                <OrangeButton2 text='Send message' className='send-message' />
                            </div>

                        </div>
                    </div>

                </div>
                <div className='white-menu-right'>
                    <div className='white-menu-right-grid'>
                        <div className='number'><span>01</span></div>
                        <div className='title'><h4> User Interface (UI) Design </h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>

                                    <p>At Blue Coast Studio, our User Interface (UI) Design service focuses on creating visually appealing and intuitive interfaces that enhance the user experience. We design with the end-user in mind, ensuring that every element is easy to navigate and aesthetically pleasing. Our team combines creativity with the latest design trends and technologies to deliver interfaces that are both functional and engaging.
                                        <br />
                                        <br />

                                        Whether you're building a website or a mobile app, we make sure that your product not only looks great but also meets your users' needs. By prioritizing usability and accessibility, we craft designs that help your brand stand out while offering a seamless experience for your customers.
                                    </p>


                                    <OrangeButton2
                                        text='Free quote'

                                    />
                                </div>
                            </div>
                        </div>
                        <div className='number'><span>02</span></div>
                        <div className='title'><h4>User Experience (UX)</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' />
                            <div className='description-parent'>
                                <div className='description-child'>

                                    <p>Our User Experience (UX) Design service is dedicated to creating seamless and enjoyable interactions for your users. We conduct thorough research and analysis to understand user behavior, ensuring that the design meets both your business goals and your audience’s needs. Our UX design process focuses on crafting intuitive and efficient user journeys that improve satisfaction and engagement.
                                        <br />
                                        <br />

                                        By combining data-driven insights with creative problem-solving, we design digital experiences that are not only functional but also memorable. From wireframing to prototyping and user testing, we ensure every aspect of the experience is fine-tuned to deliver results that delight your users and support your brand's success.</p>

                                    <OrangeButton2
                                        text='Free quote'

                                    />
                                </div>
                            </div></div>
                        <div className='number'><span>03</span></div>
                        <div className='title'><h4>SEO & SEM</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' /> <div className='description-parent'>
                            <div className='description-child'>

                                <p>SEO & SEM are essential for high visibility and reaching your target audience. Our comprehensive services cover search engine optimization (SEO) and search engine marketing (SEM). Our team of experts understands search engine algorithms and can optimize your website effectively.
                                    <br />
                                    <br />

                                    With our SEO & SEM services, you'll drive more traffic, improve rankings, and increase conversions. Whether you're a small business or a large e-commerce store, our professional services will help you succeed online and achieve your business goals.</p>

                                <OrangeButton2
                                    text='Free quote'

                                />
                            </div>
                        </div></div>
                        <div className='number'><span>04</span></div>
                        <div className='title'><h4>Responsive Design</h4><img src={Arrow2} alt='arrow-right' className='arrow-right' /> <div className='description-parent'>
                            <div className='description-child'>

                                <p>Responsive Design service ensures that your website or application looks and performs perfectly across all devices. We craft designs that adapt seamlessly to different screen sizes, from desktops to tablets and smartphones, providing an optimal user experience on every platform. With a focus on flexibility and accessibility, we help you reach a wider audience without compromising on functionality or aesthetics.
                                    <br />
                                    <br />

                                    Using the latest techniques in responsive web design, we make sure that your content is easy to navigate and interact with, no matter the device. Our approach not only enhances user satisfaction but also improves site performance and SEO, ensuring your digital presence stays competitive in an increasingly mobile-first world.</p>

                                <OrangeButton2
                                    text='Free quote'
                                />
                            </div>
                        </div></div>
                        <div className='number'><span>05</span></div>
                        <div className='title'><h4>Prototyping and Testing</h4> <img src={Arrow2} alt='arrow-right' className='arrow-right' /> <div className='description-parent'>
                            <div className='description-child'>
                                <p>Prototyping and Testing service is designed to bring your ideas to life while ensuring their effectiveness. Through interactive prototypes, we give you a tangible preview of your product before development begins, allowing for early feedback and adjustments. This approach helps to refine functionality, layout, and design, ensuring that your project meets user expectations from the start.
                                    <br />
                                    <br />
                                    Once the prototype is ready, we conduct thorough testing with real users to identify any potential issues and optimize the user experience. By validating ideas early in the process, we minimize risks and ensure a smooth development phase. Our goal is to deliver a product that not only meets your vision but also provides a flawless experience for your users.</p>

                                <OrangeButton2
                                    text='Free quote'

                                />
                            </div>
                        </div></div>
                        <div className='number'><span>06</span></div>
                        <div className='title'><h4>Content Marketing </h4><img src={Arrow2} alt='arrow-right' className='arrow-right' /> <div className='description-parent'>
                            <div className='description-child'>

                                <p>We are well aware that content marketing is a powerful strategy that helps attract and engage target audiences through valuable and relevant content. From strategy development to content creation and distribution, we are with you every step of the way.
                                    <br />
                                    <br />

                                    Our team understands the importance of creating engaging and informative content. With strategic content marketing, you can establish your brand as a thought leader, increase organic traffic, and build long-term customer relationships. Start creating valuable content with us and attract potential audiences!</p>

                                <OrangeButton2
                                    text='Free quote'
                                />
                            </div>
                        </div></div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default WhiteMenuSection